import { OperationTypes } from 'interfaces/Operations'

export const statusOperation = (status: OperationTypes | undefined) => {
    if (!status) return
    const optionsStatus = {
        INCLUSAO_REGISTRO: 'Inclusão Registro ',
        ALTERACAO_REGISTRO: 'Alteração Registro',
        ALTERACAO_ADITIVO: 'Alteração Aditivo',
        INCLUSAO_ADITIVO: 'Inclusão Aditivo',
        INCLUSAO_ANEXO: 'Inclusão de Anexo'
    }

    return optionsStatus[status]
}
